/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFall = createReactComponent("outline", "fall", "IconFall", [["path", { "d": "M11 21l1 -5l-1 -4l-3 -4h4l3 -3", "key": "svg-0" }], ["path", { "d": "M6 16l-1 -4l3 -4", "key": "svg-1" }], ["path", { "d": "M6 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-2" }], ["path", { "d": "M13.5 12h2.5l4 2", "key": "svg-3" }]]);

export { IconFall as default };
//# sourceMappingURL=IconFall.mjs.map
